import React, { useMemo, useState } from 'react';
import { TEXT_COLOR } from '../theme';
import { Link as RouterLink } from 'react-router';
import { useSelector } from 'react-redux';
import { Alert, Box, Button, CircularProgress, Link, Typography } from '@mui/material';
import useResetPassword from '../hooks/useResetPassword';
import { withLanguage } from './common/Texts';
import AuthShell from './auth/AuthShell';
import PasswordField from './auth/PasswordField';

export default function ResetPassword() {
    const {
        username, newPassword, setNewPassword, repeatPassword, setRepeatPassword,
        invalidToken, resolving, error, loading, submit,
    } = useResetPassword();
    const [showPassword, setShowPassword] = useState(false);
    const language = useSelector((state) => state.user.language);
    const t = useMemo(() => withLanguage(language), [language]);

    const onSubmit = (e) => {
        e.preventDefault();
        if (!loading && !resolving && !invalidToken) submit();
    };

    const toggleShow = () => setShowPassword((v) => !v);

    return (
        <AuthShell onSubmit={onSubmit}>
            {resolving ? (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress size={28} />
                </Box>
            ) : invalidToken ? (
                <>
                    <Alert severity="error" variant="outlined">
                        {t('request_password_reset_error_2')}
                    </Alert>
                    <Box sx={{ textAlign: 'center' }}>
                        <Link
                            component={RouterLink} to="/reset-password-request"
                            variant="body2" underline="hover" sx={{ color: TEXT_COLOR }}
                        >
                            {t('forgot_password')}
                        </Link>
                    </Box>
                </>
            ) : (
                <>
                    <Typography variant="h6" align="center" sx={{ fontWeight: 700 }}>
                        {`${t('hello')}, ${username}!`}
                    </Typography>

                    {error && <Alert severity="error" variant="outlined">{error}</Alert>}

                    <PasswordField
                        id="new-password"
                        name="newPassword"
                        label={t('reset_password_enter')}
                        autoComplete="new-password"
                        value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
                        show={showPassword} onToggleShow={toggleShow}
                    />

                    <PasswordField
                        id="repeat-password"
                        name="repeatPassword"
                        label={t('repeat_password_repeat')}
                        autoComplete="new-password"
                        value={repeatPassword} onChange={(e) => setRepeatPassword(e.target.value)}
                        show={showPassword} onToggleShow={toggleShow}
                    />

                    <Button
                        type="submit" fullWidth variant="contained" color="primary"
                        disabled={loading}
                        startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
                    >
                        {t('reset_password_button')}
                    </Button>
                </>
            )}
        </AuthShell>
    );
}
